export default function SpecialistToLeader() {
  const problems = [
    'руководитель продолжает делать работу сотрудников сам;',
    'не умеет делегировать;',
    'боится потерять контроль;',
    'избегает непопулярных решений;',
    'не умеет давать негативную обратную связь;',
    'пытается мотивировать только деньгами;',
    'слишком сильно давит на сотрудников;',
    'либо, наоборот, избегает требовательности;',
    'сотрудники ждут постоянных указаний;',
    'руководитель становится «главным исполнителем» команды.',
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-6">
              Почему сильный специалист не всегда становится лидером
            </h2>
            <p className="text-base text-gray-600 leading-relaxed mb-4">
              Компания повышает сильного специалиста до руководителя. Он отлично знает профессию. Но новая роль требует совершенно других навыков.
            </p>
            <p className="text-base text-gray-600 leading-relaxed mb-4">
              Специалист привык <strong>сам хорошо выполнять работу</strong>. Руководитель должен научиться <strong>добиваться результата через других людей</strong>.
            </p>

            <div className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 mt-6">
              <h3 className="font-bold text-gray-900 text-sm mb-4">Типичные проблемы, с которыми сталкиваются новые руководители:</h3>
              <ul className="space-y-2">
                {problems.map((p, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-alert-line text-amber-500 mt-0.5 flex-shrink-0"></i>
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div>
            <div className="bg-white rounded-xl border border-teal-200 p-6 md:p-8">
              <div className="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center mb-5">
                <i className="ri-lightbulb-line text-teal-700 text-xl"></i>
              </div>
              <p className="text-base text-gray-700 leading-relaxed mb-4">
                <strong>Лидерство — не врождённое качество</strong>, а набор управленческих навыков и моделей поведения, которые можно развивать.
              </p>
              <p className="text-sm text-gray-600 leading-relaxed">
                Когда руководитель осознанно развивает лидерские компетенции, он перестаёт быть «главным исполнителем» и начинает управлять командой — ставить задачи, делегировать, давать обратную связь, развивать сотрудников и добиваться результата не за счёт личных усилий, а через эффективную работу команды.
              </p>
            </div>

            <div className="mt-6 p-6 bg-teal-50 rounded-xl border border-teal-200">
              <p className="text-sm text-teal-800 leading-relaxed">
                <strong>Главный переход:</strong> от позиции «я сделаю сам, так быстрее и качественнее» к позиции «моя задача — создать условия, в которых сотрудники сделают так же качественно, но без моего постоянного участия».
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}